// Intercom 右下角啟動按鈕 iframe selector
const INTERCOM_LAUNCHER_SELECTOR = 'iframe[name^="intercom-"]';
// 白色主內容區域 selector，拖曳時會限制在這個範圍內
const CONTENT_WRAPPER_SELECTOR = ".main .content-wrapper";

// 在 Intercom launcher 上方加一層透明拖曳層
// 頁面重整後維持 Intercom 預設位置；使用者拖曳後才在當前頁面套用自訂位置
function enableIntercomLauncherDrag() {
    if (window.__rcmIntercomLauncherDrag) return;
    window.__rcmIntercomLauncherDrag = true;

    // 目前畫面上的 Intercom 啟動按鈕
    let launcher = null;
    // 使用者拖曳後的位置；null 代表維持 Intercom 預設右下角
    let position = null;
    // 是否正在拖曳
    let dragging = false;
    // 本次按下後是否有真的拖動，用來區分 click 與 drag
    let moved = false;
    // Intercom 對話框是否已開啟，用來判斷點擊小按鈕時要 show 還是 hide
    let messengerVisible = false;
    // 滑鼠按下時的 X 座標，用來計算滑鼠水平移動距離
    let startX = 0;
    // 滑鼠按下時的 Y 座標，用來計算滑鼠垂直移動距離
    let startY = 0;
    // 滑鼠按下時 launcher 左上角的 X 座標，拖曳時會加上滑鼠水平移動距離
    let originX = 0;
    // 滑鼠按下時 launcher 左上角的 Y 座標，拖曳時會加上滑鼠垂直移動距離
    let originY = 0;

    // 透明拖曳層：不改 Intercom DOM 結構，只蓋在 launcher 上方接收拖曳事件
    const layer = document.createElement("div");
    Object.assign(layer.style, {
        position: "fixed",
        zIndex: 2147483647,
        display: "none",
        cursor: "grab",
        pointerEvents: "auto",
        touchAction: "none",
    });
    document.body.appendChild(layer);

    // 取得目前可拖曳的白色主內容範圍，找不到時退回整個畫面
    const getDragBounds = () => {
        const contentWrapper = document.querySelector(CONTENT_WRAPPER_SELECTOR);
        const rect = contentWrapper ? contentWrapper.getBoundingClientRect() : document.documentElement.getBoundingClientRect();

        return {
            left: Math.max(0, rect.left),
            top: Math.max(0, rect.top),
            right: Math.min(window.innerWidth, rect.right),
            bottom: Math.min(window.innerHeight, rect.bottom),
        };
    };

    // 把數值限制在指定範圍內
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    // 把 launcher 左上角座標限制在白色主內容範圍內
    const getBoundedPosition = (x, y, rect) => {
        const bounds = getDragBounds();
        const maxX = Math.max(bounds.left, bounds.right - rect.width);
        const maxY = Math.max(bounds.top, bounds.bottom - rect.height);

        return {
            x: clamp(x, bounds.left, maxX),
            y: clamp(y, bounds.top, maxY),
        };
    };

    // 確認候選小按鈕在自己的中心點是最上層元素，避免抓到被 Intercom 其他 iframe 蓋住的舊 launcher
    const isTopMostLauncher = (element) => {
        const rect = element.getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;
        const originalPointerEvents = layer.style.pointerEvents;
        layer.style.pointerEvents = "none";
        const topElement = document.elementFromPoint(x, y);
        layer.style.pointerEvents = originalPointerEvents;

        return topElement === element || element.contains(topElement);
    };

    // 找目前可見的 Intercom 小按鈕；用尺寸排除已開啟的大對話框
    const findLauncher = () => {
        const candidates = Array.from(document.querySelectorAll(INTERCOM_LAUNCHER_SELECTOR));
        const smallCandidates = candidates.filter((element) => {
            const rect = element.getBoundingClientRect();
            return rect.width && rect.height && rect.width <= 120 && rect.height <= 120;
        });
        return smallCandidates.find(isTopMostLauncher);
    };

    // 讓透明拖曳層跟 launcher 的位置和大小一致
    const moveLayerTo = (rect) => {
        Object.assign(layer.style, {
            left: `${rect.left}px`,
            top: `${rect.top}px`,
            width: `${rect.width}px`,
            height: `${rect.height}px`,
            display: rect.width && rect.height ? "block" : "none",
        });
    };

    // 把 launcher 移到指定位置，同時把透明拖曳層一起移過去
    const moveLauncherTo = (x, y) => {
        if (!launcher) return;
        const rect = launcher.getBoundingClientRect();
        position = getBoundedPosition(x, y, rect);

        launcher.style.setProperty("position", "fixed", "important");
        launcher.style.setProperty("left", `${position.x}px`, "important");
        launcher.style.setProperty("top", `${position.y}px`, "important");
        launcher.style.setProperty("right", "auto", "important");
        launcher.style.setProperty("bottom", "auto", "important");

        moveLayerTo({
            left: position.x,
            top: position.y,
            width: rect.width,
            height: rect.height,
        });
    };

    // 清掉拖曳留下的 inline 位置，讓 Intercom 回到原本右下角
    const clearLauncherPosition = () => {
        position = null;
        Array.from(document.querySelectorAll(INTERCOM_LAUNCHER_SELECTOR)).forEach((element) => {
            element.style.removeProperty("left");
            element.style.removeProperty("top");
            element.style.removeProperty("right");
            element.style.removeProperty("bottom");
            element.style.removeProperty("position");
        });
    };

    // 回到 Intercom 原本的右下角位置；切換畫面時清掉本次拖曳留下的 inline 位置
    window.__rcmResetIntercomLauncherPosition = () => {
        clearLauncherPosition();
        window.setTimeout(sync, 0);
    };

    // Intercom 開啟或關閉後會替換右下角按鈕，所以需要重新同步拖曳層
    if (typeof window.Intercom === "function") {
        window.Intercom("onShow", () => {
            messengerVisible = true;
            clearLauncherPosition();
            layer.style.display = "none";
            window.setTimeout(sync, 300);
        });
        window.Intercom("onHide", () => {
            messengerVisible = false;
            window.setTimeout(sync, 300);
        });
    }

    // 同步 Intercom 狀態：launcher 可能晚載入或被 Intercom 重排，所以定期對齊
    const sync = () => {
        document.body.appendChild(layer);

        if (messengerVisible) {
            layer.style.display = "none";
            return;
        }

        launcher = findLauncher();
        if (!launcher) {
            layer.style.display = "none";
            return;
        }

        if (position) {
            moveLauncherTo(position.x, position.y);
        } else {
            moveLayerTo(launcher.getBoundingClientRect());
        }
    };

    layer.addEventListener("pointerdown", (event) => {
        if (messengerVisible) return;
        sync();
        if (!launcher) return;

        // 記住拖曳起點，後面用滑鼠位移換算 launcher 新位置
        const rect = launcher.getBoundingClientRect();
        dragging = true;
        moved = false;
        startX = event.clientX;
        startY = event.clientY;
        originX = rect.left;
        originY = rect.top;
        layer.style.cursor = "grabbing";
        if (layer.setPointerCapture) layer.setPointerCapture(event.pointerId);
        event.preventDefault();
    });

    document.addEventListener("pointermove", (event) => {
        if (!dragging) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        moved = moved || Math.abs(dx) > 3 || Math.abs(dy) > 3;
        moveLauncherTo(originX + dx, originY + dy);
    });

    document.addEventListener("pointerup", () => {
        if (!dragging) return;
        dragging = false;
        layer.style.cursor = "grab";
        if (!moved && typeof window.Intercom === "function") {
            window.Intercom(messengerVisible ? "hide" : "show");
        }
        window.setTimeout(sync, 300);
    });

    window.addEventListener("resize", sync);
    window.setInterval(sync, 500);
    sync();
}

export function loadIntercomWidget(appId) {
    window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: appId,
    };

    (function () {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            var d = document;
            var i = function () {
                i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
                i.q.push(args);
            };
            w.Intercom = i;
            var l = function () {
                var s = d.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = `https://widget.intercom.io/widget/${appId}`;
                var x = d.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === "complete") {
                l();
            } else if (w.attachEvent) {
                w.attachEvent("onload", l);
            } else {
                w.addEventListener("load", l, false);
            }
        }
    })();

    enableIntercomLauncherDrag();
}

// 給 router 切換畫面時呼叫，讓 Intercom launcher 回到預設右下角
export function resetIntercomLauncherPosition() {
    if (typeof window.__rcmResetIntercomLauncherPosition === "function") window.__rcmResetIntercomLauncherPosition();
}



// WEBPACK FOOTER //
// ./src/components/intercomWidget.js